import { render, staticRenderFns } from "./CallOriginatorRule.vue?vue&type=template&id=7ef40ad0&"
import script from "./CallOriginatorRule.vue?vue&type=script&lang=ts&"
export * from "./CallOriginatorRule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports